import { type TextFieldProps } from '@mui/material'
import { isFunction } from 'lodash-es'

type SlotProps = TextFieldProps['slotProps']

interface WithReadOnlyParams {
  readOnly?: boolean
  slotProps: SlotProps
  InputProps?: TextFieldProps['InputProps']
}

/**
 * Writes `readOnly` into the input slot, which is what MUI turns into both the native attribute and
 * the `MuiInputBase-readOnly` class the theme styles.
 *
 * Returns `slotProps` untouched when `readOnly` is absent, and folds `InputProps` in underneath the
 * slot otherwise — MUI drops the deprecated `InputProps` wholesale once `slotProps.input` exists.
 */
export const withReadOnly = ({ readOnly, slotProps, InputProps }: WithReadOnlyParams): SlotProps => {
  if (readOnly === undefined) {
    return slotProps
  }

  const input = slotProps?.input

  return {
    ...slotProps,
    input: isFunction(input)
      ? (ownerState) => ({ ...InputProps, ...input(ownerState), readOnly })
      : { ...InputProps, ...input, readOnly },
  }
}
